// extracted by mini-css-extract-plugin
export default {"select":"CalendarGroupModeSwitch_select__4Sxd6"};